module.exports = __webpack_public_path__ + "static/media/BG2.0040466c.png";